import React from 'react';

export function NotFoundPage(): JSX.Element {
  return <div>Not found page</div>
}